module.exports = __webpack_public_path__ + "static/media/texture (29).10a135ab.jpg";